// src/components/DebugStyles.tsx
import { useEffect } from "react";

export const DebugStyles = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      // Check if styles are applied
      const testDiv = document.createElement("div");
      testDiv.className = "hidden md:block bg-primary text-white";
      document.body.appendChild(testDiv);

      const styles = window.getComputedStyle(testDiv);
      console.log("🔍 Style test:", {
        display: styles.display,
        backgroundColor: styles.backgroundColor,
        color: styles.color,
        md_query: window.matchMedia("(min-width: 768px)").matches,
      });

      testDiv.remove();
    }
  }, []);

  return null;
};
